/*
 * View for a sortable list
 */

define([
  "marionette",
  "jquery",
  "modules/shared/sortableList/template/sortableListTemplate.html",
], function (Marionette, $, SortableListTemplate) {
  "use strict";

  const SortableListView = {};

  const ReplaceRegionType = Marionette.Region.extend({
    //region mod that inserts the view into the region without extra divs
    open: function (view) {
      this.$el.replaceWith(view.el); //replace container instead of appending inside it
    },
  });
  SortableListView.sortableListLayout = Marionette.Layout.extend({
    template: SortableListTemplate,
    className: "max-height position-relative",
    handleResize: function () {
      //be ready for window resizing by adjusting the height of the title
      $(window).on("resize", () => this.showTitle());
    },
    hideControls: function () {
      this.$el.find("#sortableListControls").hide();
      //remove padding on sortableList
      this.$el.find("#sortableListBody").addClass("no-controls");
      this.$el.find("#headSelector").addClass("no-controls");
    },
    hideHeaders: function () {
      this.$el.find("thead").addClass("invisible-header");
      this.$el.find("#headSelector").hide();
    },
    regions: {
      head: "thead",
      headSelector: "#headSelector",
      pagination: "#pagination",
      counter: "#counter",
      titleModule: "#sortableListTitle",
      body: {
        selector: "tbody",
        regionType: ReplaceRegionType,
      },
    },
    removeCounter: function () {
      this.$el.find("#counter").remove();
      //adjust the span of the pagination
      this.$el.find("#pagination").removeClass("span9").addClass("span12");
    },
    showTitle: function () {
      const title = this.$el.find("#sortableListTitle");
      const body = this.$el.find("#sortableListBody");
      title.show();
      //remove any previous jquery styling
      body.removeAttr("style");
      //adjust the margins and padding on the sortable list body to account for the added height of the title
      const titleHeight = title.height();
      const currentPadding = parseInt(body.css("padding-top"), 10);
      const currentMargin = parseInt(body.css("margin-top"), 10);
      body.css("padding-top", currentPadding + titleHeight + "px");
      body.css("margin-top", currentMargin - titleHeight + "px"); //subtract because currentMargin is negative
      //also adjust the header selector
      //        var headerSelector = this.$el.find("#headSelector");
      //        var currentTop = parseInt(headerSelector.css("top"), 10);
      //        headerSelector.css("top", currentTop + titleHeight);
    },
  });

  return SortableListView;
});
